import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { IBetslip } from '../../../../../bet-generation/models';
import { IncorrectOptionsCountPreCheckError } from '../../../../errors/pre-check/incorrect-options-count-pre-check-error';
import { ErrorDetailsSpecifier } from '../../../../errors/pre-check/pre-check-error';
import { SingleBetValidationContext } from '../../../../models/models';
import { ISingleBetBetslipValidator } from '../validators';

@Injectable()
export class SingleBetIncorrectOptionsCountValidator implements ISingleBetBetslipValidator<IncorrectOptionsCountPreCheckError> {
    constructor(private config: BetslipConfig) {}

    validate(_: IBetslip, context: SingleBetValidationContext): IncorrectOptionsCountPreCheckError[] {
        const picksCount = context.validPicksCount;

        if (picksCount < 1) {
            return [new IncorrectOptionsCountPreCheckError(1, picksCount, ErrorDetailsSpecifier.SelectMinSingleBets)];
        }

        if (picksCount > this.config.maxBetslipBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.maxBetslipBets, picksCount, ErrorDetailsSpecifier.PicksMaximum)];
        }

        return [];
    }
}
